import {parseUrlQuery} from "./parse-url-query";

export const removeURLParameter = ({url, parameter} : {url: string, parameter: string }) : string  => {
    const [path, params] = url.split('?');
    const pars = params.split('&');  
    if (pars.length > 0) {
        const encodedParam = encodeURIComponent(parameter);
        for (let i = pars.length; i-- > 0;) {    
            let query = pars[i].split('=')[0];
            if( query === encodedParam) {
                pars.splice(i, 1);
            }
        }
        return path + (pars.length > 0 ? '?' + pars.join('&') : '');
    }
    return path;
}

export const removeURLParameterFromWindow = ({parameter} : {parameter: string}) : void => {
    if(parseUrlQuery(window.location.search)?.[parameter]) {
        const newUrl = removeURLParameter({
            url: window.location.toString(), 
            parameter,
        });
        if(newUrl) {
            window.history.replaceState(window.history.state, null, newUrl);
        }
    }
}
